import React from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  GetAgeBand,
  AddAgeBand,
  DeleteAgeBand,
} from "../../../../api/User/ACG/AgeBandApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";

const schema = Yup.object().shape({
  age_Band: Yup.string().matches(/^[a-zA-Z0-9\s-]*$/, 'No special characters are allowed.').required("Please enter age band"),
  ruB_0: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter RUB 0"),
  ruB_1: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter RUB 1"),
  ruB_2: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter RUB 2"),
  ruB_3: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter RUB 3"),
  ruB_4: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter RUB 4"),
  ruB_5: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter RUB 5"),
});

const AgeBandRub = () => {
  const [data, setData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const buttonRef = useRef(null);
  const column = [
    {
      title: "Age_Band",
      field: "age_Band",
    },
    {
      title: "RUB 0",
      field: "ruB_0",
      render: (rowData) => (+rowData.ruB_0 * 100).toFixed(2)  + "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.ruB_0  * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
    {
      title: "RUB 1",
      field: "ruB_1",
      render: (rowData) => (+rowData.ruB_1  * 100).toFixed(2) + "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.ruB_1  * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
    {
      title: "RUB 2",
      field: "ruB_2",
      render: (rowData) => (+rowData.ruB_2  * 100).toFixed(2) + "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.ruB_2  * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
    {
      title: "RUB 3",
      field: "ruB_3",
      render: (rowData) => (+rowData.ruB_3  * 100).toFixed(2)+ "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.ruB_3  * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
    {
      title: "RUB 4",
      field: "ruB_4",
      render: (rowData) => (+rowData.ruB_4  * 100).toFixed(2) + "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.ruB_4  * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
    {
      title: "RUB 5",
      field: "ruB_5",
      render: (rowData) => (+rowData.ruB_5  * 100).toFixed(2)+ "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.ruB_5  * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getAgeBandDetailsData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getAgeBandDetailsData();
  }, []);

  const getAgeBandDetailsData = () => {
    GetAgeBand()
      .then((res) => {
        if(res.status === 200 || res.status === 204){
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const { age_Band, ruB_0, ruB_1, ruB_2, ruB_3, ruB_4, ruB_5 } = values;
    const payload = {
      id: 0,
      age_Band,
      ruB_0: +ruB_0,
      ruB_1: +ruB_1,
      ruB_2: +ruB_2,
      ruB_3: +ruB_3,
      ruB_4: +ruB_4,
      ruB_5: +ruB_5,
    };

    if (witchAction === "add") {
      AddAgeBand(payload).then((res) => {
        if(res.status === 200 || res.status === 204){
          setIsGetData(true);
          toastFile("new");
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      AddAgeBand({
        ...payload,
        id: selectedRowData.id,
      }).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("update");
        setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            Age Band
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteAgeBand(selectedRowData?.id).then((res) => {
                  if(res.status === 200 || res.status === 204){
                    toastFile("delete");
                    setIsGetData(true);
                    setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                age_Band: selectedRowData?.age_Band,
                ruB_0: (selectedRowData?.ruB_0 ?? 0),
                ruB_1: (selectedRowData?.ruB_1 ?? 0),
                ruB_2: (selectedRowData?.ruB_2 ?? 0),
                ruB_3: (selectedRowData?.ruB_3 ?? 0),
                ruB_4: (selectedRowData?.ruB_4 ?? 0),
                ruB_5: (selectedRowData?.ruB_5 ?? 0),
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {witchAction === "delete" ? (
                    <div className="text-wrap">
                      Are you sure that you want to delete the record?
                    </div>
                  ) : (
                    <>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="Age_Band"
                            name="age_Band"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="RUB 0"
                            name="ruB_0"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="RUB 1"
                            name="ruB_1"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="RUB 2"
                            name="ruB_2"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="RUB 3"
                            name="ruB_3"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="RUB 4"
                            name="ruB_4"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Row className="mb-2 gap-3">
                          <Col style={{ maxWidth: "48%" }}>
                            <CustomInputField
                              label="RUB 5"
                              name="ruB_5"
                              maxLength={10}
                              value={values}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              touched={touched}
                              errors={errors}
                              isRequired
                            />
                          </Col>
                        </Row>
                      </Row>
                    </>
                  )}
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{fontSize:"12px"}}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add Age Band
        </CustomButton>
      </div>
      <CustomMaterialTable
        isExport={true}
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
      />
    </div>
  );
};

export default AgeBandRub;
